import React from 'react'
import ReactDOM from 'react-dom/client'
import MessageApp from './MessageApp'
import './styles/pixel-theme.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <MessageApp />
  </React.StrictMode>,
)